import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgModule } from '@angular/core';
import { Globals } from '../../_models/globals';
import { AccessSecurity } from '../../_models/accessSecurity';
import { Router } from '@angular/router';
import { Subject, Subscription, timer } from 'rxjs';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import Chart from 'chart.js';
import * as moment from 'moment';
declare var Chart: any;
declare var require: any;
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal, NgbModalRef, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LoginPopupComponent } from '../../admin-container/login-popup/login-popup.component';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  public products: any;
  invoice: any;
  orders: any = {};
  ndrSummary: any = {};
  inboundOrders: any = {};
  shipments: any;
  private subscriptions = new Subscription();
  tabClicked: string = "paid";
  onHoldCount: any;
  getDatesList: any = [];
  dateSelect: any;
  demoPopUP: string = 'N';
  ordersCountSpinner = false;
  bubbleOptions: any = {};
  shipmentByCarrierInfo: any;
  storeInfo: any;
  topFiveProducts: any;
  topFiveLocation: any;

  constructor(private spinner: NgxSpinnerService, private ngbModal: NgbModal, private alertService: AlertService, private http: HttpClient, public activeModal: NgbActiveModal, public g: Globals, public accessSec: AccessSecurity, public user: User, public router: Router, private api: ApiIntegration) {
    this.g.page = "Dashboard";
    this.g.accountOwnerName = this.user.accountOwnerName;

    this.api.getCustomerAccountingSummary().subscribe((data: any) => {
      this.invoice = data;
    }, err => {
      console.log(err);
    });

    this.api.getShipmentsByCarriers().subscribe((data: any) => {
      this.shipmentByCarrierInfo = data.carrierResponseList;
    }, err => {
      console.log(err);
    });

    this.api.getOrderByStore().subscribe((data: any) => {
      this.storeInfo = data.orderByResponseList;
    }, err => {
      console.log(err);
    });

    this.api.organizationsTop5Products().subscribe((data: any) => {
      this.topFiveProducts = data;
    }, err => {
      console.log(err);
    });

    this.api.getTopFiveOrderDeliveredLocations().subscribe((data: any) => {
      this.topFiveLocation = data.locations;
    }, err => {
      console.log(err);
    });

    this.getDatesList = [
      { label: 'Today', fromDate: moment().format('MM/DD/YYYY'), toDate: moment().format('MM/DD/YYYY') },
      { label: 'Yesterday', fromDate: moment().format('MM/DD/YYYY'), toDate: moment().format('MM/DD/YYYY') },
      {
        label: '7 Days',
        fromDate: moment().subtract(7, 'days').format('MM/DD/YYYY'),
        toDate: moment().format('MM/DD/YYYY')
      },
      {
        label: '1 Month',
        fromDate: moment().subtract(30, 'days').format('MM/DD/YYYY'),
        toDate: moment().format('MM/DD/YYYY')
      },
      {
        label: '6 Month',
        fromDate: moment().subtract(180, 'days').format('MM/DD/YYYY'),
        toDate: moment().format('MM/DD/YYYY')
      }
    ];
    this.dateSelect = {
      label: '6 Month',
      fromDate: moment().subtract(180, 'days').format('MM/DD/YYYY'),
      toDate: moment().format('MM/DD/YYYY')
    };
    this.initializeCharts();
    if (this.user.role == "ACCOUNT_OWNER" || this.user.role == "DEMO_ACCOUNT") {
      if (this.g.profilePopupDisplay == 0) {
        if (!this.g.profilePopup.isMOUDocPresent || !this.g.profilePopup.isKYCVerified || !this.g.profilePopup.isDefaultAddressPresent || !this.g.profilePopup.isChannelPresent) {
          this.openPopup();
        }
      }
    }
  }

  openPopup() {
    const modalRef = this.ngbModal.open(LoginPopupComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'model-width',
      backdrop: "static",
      keyboard: false
    });
    modalRef.result.then((response) => {
    }, (reason) => {
    });
    if (this.g.sampleDataPopupDisplay == 0) {
      if (this.user.loadedSampleData == 'Y') {
        this.demoPopUP = 'N';
      } else {
        this.demoPopUP = 'Y';
      }
    }
  }

  populateTabData(triggered) {
    this.tabClicked = triggered;
  }

  demoPopupClose() {
    this.demoPopUP = 'n';
    this.g.sampleDataPopupDisplay = 1;
  }

  ngOnInit() { }

  getRandomColorHex() {
    var hex = "0123456789ABCDEF",
      color = "#";
    for (var i = 1; i <= 6; i++) {
      color += hex[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  navigateToOrder(tab) {
    this.g.pageTab = tab;
    this.router.navigate(['/admin/orders']);
  }

  navigateToShipment() {
    this.router.navigate(['/admin/shipmentList']);
  }

  navigateToProduct(tab) {
    this.g.pageTab = tab;
    this.router.navigate(['/admin/inventories']);
  }

  navigateToInvoice(tab) {
    this.g.pageTab = tab;
    this.router.navigate(['/admin/invoices']);
  }
  navigateToWallet() {
    this.router.navigate(['/admin/credits']);
  }

  initializeCharts() {
    var options1 = {
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            display: false
          }
        }]
      }
    }
    var options2 = {
      tooltips: {
        intersect: false
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            min: 0,
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            min: 0,
            display: false
          }
        }]
      }
    }

    this.bubbleOptions = {
      rotation: 2 * Math.PI,
      circumference: 2 * Math.PI,
      legend: {
        display: true,
        position: 'left',
      },
      scales: {
        xAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            min: -100,
            display: false
          }
        }],
        yAxes: [{
          gridLines: {
            display: false
          },
          ticks: {
            min: -100,
            display: false
          }
        }]
      }
    }

    if (!this.dateSelect) {
      this.dateSelect = {
        label: '6 Month',
        fromDate: moment().subtract(180, 'days').format('MM/DD/YYYY'),
        toDate: moment().format('MM/DD/YYYY')
      };
    }
    let query: any = {
      accountOwnerId: this.user.accountOwnerId,
      organizationId: 1
    }
    query = { ...query, ...this.dateSelect };
    delete query.label;
    this.subscriptions.add(timer(0, 120000).subscribe((t) => {
      this.spinner.show('ordersCountSpinner');
      this.ordersCountSpinner = true;
      this.api.getOrdersCount().subscribe((data: any) => {
        this.orders = data;
        let data1 = [this.orders.rtoCount, this.orders.deliveryAndReturnTotalCount];
        let data2 = [this.orders.returnsCount, this.orders.deliveryAndReturnTotalCount];
        var rtoCount = document.getElementById('rtoCountChart');
        var rtoCountChart = new Chart(rtoCount, {
          type: 'pie',
          data: {
            labels: [
              'RTO', 'Total Orders'
            ],
            datasets: [
              {
                data: data1,
                backgroundColor: [
                  "#28a745",
                  "#36A2EB"
                ],
                opacity: 0.1
              }]
          },
          options: this.bubbleOptions
        });
        var returnsCount = document.getElementById('returnsCountChart');
        var returnsCountChart = new Chart(returnsCount, {
          type: 'pie',
          data: {
            labels: [
              'Returns', 'Total Orders'
            ],
            datasets: [
              {
                data: data2,
                backgroundColor: [
                  "#FFCE56",
                  "#D3D3D3"
                ],
                opacity: 0.1
              }]
          },
          options: this.bubbleOptions
        });
        this.ordersCountSpinner = false;
        this.spinner.hide('ordersCountSpinner');
      }, err => {
        console.log(err);
        this.spinner.hide('ordersCountSpinner');
      });
      this.api.getNDRReport().subscribe((data: any) => {
        this.ndrSummary = data;
        let data1 = [this.ndrSummary.firstAttempt, this.ndrSummary.totalAttempts];
        let data2 = [this.ndrSummary.secondAttempt, this.ndrSummary.totalAttempts];
        let data3 = [this.ndrSummary.thirdAttempt, this.ndrSummary.totalAttempts];
        var firstAttemptCount = document.getElementById('firstAttemptChart');
        var firstAttemptChart = new Chart(firstAttemptCount, {
          type: 'pie',
          data: {
            labels: [
              '1st Attempt', 'Total Attempts'
            ],
            datasets: [
              {
                data: data1,
                backgroundColor: [
                  "#28a745",
                  "#36A2EB"
                ],
                opacity: 0.1
              }]
          },
          options: this.bubbleOptions
        });
        var secondAttemptCount = document.getElementById('secondAttemptChart');
        var secondAttemptChart = new Chart(secondAttemptCount, {
          type: 'pie',
          data: {
            labels: [
              '2nd Attempt', 'Total Attempts'
            ],
            datasets: [
              {
                data: data2,
                backgroundColor: [
                  "#FFCE56",
                  "#D3D3D3"
                ],
                opacity: 0.1
              }]
          },
          options: this.bubbleOptions
        });
        var thirdAttemptCount = document.getElementById('thirdAttemptChart');
        var thirdAttemptChart = new Chart(thirdAttemptCount, {
          type: 'pie',
          data: {
            labels: [
              '3rd Attempt', 'Total Attempts'
            ],
            datasets: [
              {
                data: data3,
                backgroundColor: [
                  "#FFCE56",
                  "#D3D3D3"
                ],
                opacity: 0.1
              }]
          },
          options: this.bubbleOptions
        });
      }, err => {
        console.log(err);
      });
    }));
  }

  graphChart(labels, data, backgroundColor, borderColor, options, chartId) {
    var readyShipmentCtx = document.getElementById(chartId);
    var readyShipmentChart = new Chart(readyShipmentCtx, {
      type: 'line',
      data: {
        labels,
        datasets: [{
          label: 'Count',
          backgroundColor,
          borderColor,
          pointRadius: 0,
          data
        }]
      },
      options
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
